/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for get institute preference by person
 * @export
 * @interface InstitutePreferencesResponse
 */
export interface InstitutePreferencesResponse {
    /**
     * The institute address preferred
     * @type {string}
     * @memberof InstitutePreferencesResponse
     */
    instituteAddress?: string;
    /**
     * The institute phone preferred
     * @type {string}
     * @memberof InstitutePreferencesResponse
     */
    institutePhone?: string;
    /**
     * The institute email preferred
     * @type {string}
     * @memberof InstitutePreferencesResponse
     */
    instituteEmail?: string;
    /**
     * Preferred institute header ID
     * @type {string}
     * @memberof InstitutePreferencesResponse
     */
    instituteHeader?: string;
}

/**
 * Check if a given object implements the InstitutePreferencesResponse interface.
 */
export function instanceOfInstitutePreferencesResponse(value: object): value is InstitutePreferencesResponse {
    return true;
}

export function InstitutePreferencesResponseFromJSON(json: any): InstitutePreferencesResponse {
    return InstitutePreferencesResponseFromJSONTyped(json, false);
}

export function InstitutePreferencesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstitutePreferencesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'instituteAddress': json['instituteAddress'] == null ? undefined : json['instituteAddress'],
        'institutePhone': json['institutePhone'] == null ? undefined : json['institutePhone'],
        'instituteEmail': json['instituteEmail'] == null ? undefined : json['instituteEmail'],
        'instituteHeader': json['instituteHeader'] == null ? undefined : json['instituteHeader'],
    };
}

export function InstitutePreferencesResponseToJSON(json: any): InstitutePreferencesResponse {
    return InstitutePreferencesResponseToJSONTyped(json, false);
}

export function InstitutePreferencesResponseToJSONTyped(value?: InstitutePreferencesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instituteAddress': value['instituteAddress'],
        'institutePhone': value['institutePhone'],
        'instituteEmail': value['instituteEmail'],
        'instituteHeader': value['instituteHeader'],
    };
}

